import React, { useState } from "react";
import { apiFetch } from "../utils/api";

const COLORES = ["#2563EB","#F97316","#16A34A","#92400E","#6B7280","#e0e0e0","#DC2626","#888","#CA8A04","#7C3AED","#DB2777","#0891B2"];
const NOMBRES = ["Azul","Naranja","Verde","Marron","Gris","Blanco","Rojo","Negro","Amarillo","Violeta","Rosado","Aqua"];

export default function FusionBuffers({mufa_id, fibras, fusionesExistentes, onGuardado, canEdit}) {
  const bufExistentes = [...new Set(fusionesExistentes.filter(f=>f.tipo==="buffer_completo").map(f=>parseInt(f.buffer_entrada)))];

  const [fibra_e,   setFibraE]   = useState("");
  const [fibra_s,   setFibraS]   = useState("");
  const [buffersSel,setBuffersSel]= useState([]);
  const [error,     setError]    = useState("");
  const [msgOk,     setMsgOk]    = useState("");
  const [saving,    setSaving]   = useState(false);

  const fibraE = fibras.find(f=>String(f.id)===String(fibra_e));
  const totalBufs = fibraE ? Math.ceil(parseInt(fibraE.tipo_hilos)/12) : 0;

  const toggleBuf = (b) => setBuffersSel(prev=>prev.includes(b)?prev.filter(x=>x!==b):[...prev,b]);

  const bufsYaGuardados = new Set(bufExistentes);

  const eliminarBuffer = async(bufNum) => {
    const ids = fusionesExistentes.filter(f=>f.tipo==="buffer_completo"&&parseInt(f.buffer_entrada)===bufNum).map(f=>f.id);
    for(const id of ids){
      await apiFetch("/mufa_diagram.php?mufa_id="+mufa_id,{method:"DELETE",headers:{"Content-Type":"application/json"},body:JSON.stringify({accion:"fusion",id})});
    }
    onGuardado();
  };

  const guardar = async() => {
    if(!fibra_e||!fibra_s){ setError("Selecciona fibra de entrada y salida"); return; }
    if(buffersSel.length===0){ setError("Selecciona al menos un buffer"); return; }
    setSaving(true); setError(""); setMsgOk("");
    const fusiones = [];
    buffersSel.forEach(b=>{
      const hilosEnBuf = Math.min(12, parseInt(fibraE.tipo_hilos)-(b-1)*12);
      for(let h=1;h<=hilosEnBuf;h++){
        fusiones.push({
          tipo:"buffer_completo",
          fibra_entrada_id:parseInt(fibra_e), buffer_entrada:b, hilo_entrada:h,
          fibra_salida_id:parseInt(fibra_s),  buffer_salida:b,  hilo_salida:h,
          direccion:"adelante", splitter_id:null, splitter_salida_num:null, notas:"",
        });
      }
    });
    const r = await apiFetch("/mufa_diagram.php?mufa_id="+mufa_id,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({accion:"fusiones_lote",fusiones})});
    setSaving(false);
    if(r.success){ setMsgOk("Guardado — "+r.guardadas+" fusiones ("+buffersSel.length+" buffers)"); setBuffersSel([]); onGuardado(); }
    else setError(r.error||"Error al guardar");
  };

  const S = {
    card:{background:"rgba(255,255,255,0.03)",borderRadius:8,padding:"12px",marginBottom:10,border:"1px solid #1e2a4a"},
    cardTitle:{fontSize:13,fontWeight:600,color:"#C4B5FD",marginBottom:8},
    select:{background:"#1a1a2e",border:"1px solid #374151",borderRadius:6,color:"#F9FAFB",padding:"6px 8px",fontSize:12,width:"100%",marginBottom:8},
    btnGuardar:{background:"#059669",color:"#fff",border:"none",borderRadius:6,padding:"10px 0",cursor:"pointer",fontSize:13,fontWeight:600,width:"100%",marginTop:8},
    btnDanger:{background:"rgba(239,68,68,0.15)",color:"#F87171",border:"1px solid rgba(239,68,68,0.3)",borderRadius:4,padding:"2px 8px",cursor:"pointer",fontSize:11},
    row:{display:"flex",alignItems:"center",gap:6,padding:"5px 8px",borderRadius:5,background:"rgba(5,150,105,0.08)",border:"1px solid #065f46",marginBottom:3},
  };

  return (
    <div>
      {/* BUFFERS GUARDADOS */}
      {bufExistentes.length>0&&(
        <div style={S.card}>
          <div style={S.cardTitle}>Buffers guardados ({bufExistentes.length})</div>
          {bufExistentes.sort((a,b)=>a-b).map(b=>{
            const color = COLORES[(b-1)%12];
            const nom   = NOMBRES[(b-1)%12];
            const count = fusionesExistentes.filter(f=>f.tipo==="buffer_completo"&&parseInt(f.buffer_entrada)===b).length;
            return (
              <div key={b} style={S.row}>
                <div style={{width:10,height:10,borderRadius:2,background:color,flexShrink:0}}/>
                <span style={{fontSize:11,color,fontWeight:600}}>B{b} {nom}</span>
                <span style={{fontSize:10,color:"#34D399"}}>══ pasa derecho →→→</span>
                <span style={{fontSize:9,color:"#4B5563"}}>({count} hilos)</span>
                <div style={{flex:1}}/>
                {canEdit&&<button onClick={()=>eliminarBuffer(b)} style={S.btnDanger}>X</button>}
              </div>
            );
          })}
        </div>
      )}

      {/* AGREGAR BUFFERS */}
      {canEdit&&(
        <div style={S.card}>
          <div style={S.cardTitle}>Agregar buffers que pasan derecho</div>
          <label style={{fontSize:11,color:"#9CA3AF"}}>Fibra de entrada</label>
          <select style={S.select} value={fibra_e} onChange={e=>{setFibraE(e.target.value);setBuffersSel([]);}}>
            <option value="">Selecciona fibra...</option>
            {fibras.map(f=><option key={f.id} value={f.id}>{f.nombre} ({f.tipo_hilos}h)</option>)}
          </select>
          <label style={{fontSize:11,color:"#9CA3AF"}}>Fibra de salida</label>
          <select style={S.select} value={fibra_s} onChange={e=>setFibraS(e.target.value)}>
            <option value="">Selecciona fibra...</option>
            {fibras.map(f=><option key={f.id} value={f.id}>{f.nombre} ({f.tipo_hilos}h)</option>)}
          </select>

          {fibra_e&&totalBufs>0&&(
            <>
              <div style={{fontSize:11,color:"#9CA3AF",marginBottom:6}}>Selecciona buffers que pasan derecho:</div>
              <div style={{display:"flex",flexWrap:"wrap",gap:6,marginBottom:8}}>
                {Array.from({length:totalBufs},(_,i)=>{
                  const b=i+1, color=COLORES[i%12], nom=NOMBRES[i%12];
                  const yaGuardado = bufsYaGuardados.has(b);
                  // Verificar si algún hilo de este buffer ya está usado en cualquier fusión
                  const hilosEnBuf = Math.min(12, parseInt(fibraE.tipo_hilos)-(b-1)*12);
                  const tieneHilosUsados = fusionesExistentes.some(f=>{
                    if(f.tipo==="buffer_completo") return false; // los propios no bloquean
                    const entraMatch = String(f.fibra_entrada_id)===String(fibra_e)&&parseInt(f.buffer_entrada)===b;
                    const salidaMatch = String(f.fibra_salida_id)===String(fibra_e)&&parseInt(f.buffer_salida)===b;
                    return entraMatch||salidaMatch;
                  });
                  const deshabilitado = yaGuardado||tieneHilosUsados;
                  const sel = buffersSel.includes(b);
                  const motivo = yaGuardado?"ya guardado":tieneHilosUsados?"hilos en uso":"";
                  return (
                    <button key={b} onClick={()=>!deshabilitado&&toggleBuf(b)}
                      title={motivo}
                      style={{display:"flex",alignItems:"center",gap:4,padding:"4px 10px",borderRadius:6,border:`1px solid ${yaGuardado?"#065f46":tieneHilosUsados?"#7f1d1d":sel?"#7C3AED":"#374151"}`,background:yaGuardado?"rgba(5,150,105,0.2)":tieneHilosUsados?"rgba(127,29,29,0.2)":sel?"rgba(124,58,237,0.3)":"transparent",cursor:deshabilitado?"not-allowed":"pointer",opacity:deshabilitado?0.6:1}}>
                      <div style={{width:8,height:8,borderRadius:2,background:color}}/>
                      <span style={{fontSize:11,color:yaGuardado?"#34D399":tieneHilosUsados?"#F87171":sel?"#C4B5FD":"#9CA3AF"}}>
                        B{b} {nom}{yaGuardado?" ✓":tieneHilosUsados?" ✗":""}
                      </span>
                    </button>
                  );
                })}
              </div>
            </>
          )}

          {error&&<p style={{color:"#F87171",fontSize:11,margin:"4px 0",padding:"4px 8px",background:"rgba(239,68,68,0.1)",borderRadius:4}}>{error}</p>}
          {msgOk&&<p style={{color:"#34D399",fontSize:12,margin:"4px 0"}}>{msgOk}</p>}
          <button onClick={guardar} disabled={saving} style={S.btnGuardar}>
            {saving?"Guardando...":"💾 Guardar "+buffersSel.length+" buffer(s)"}
          </button>
        </div>
      )}
    </div>
  );
}
